interface Props {
  is_multi_select: boolean;
  checked: boolean;
  checkedAndDisabled?: boolean;
}

const SvgRadioCheckbox: React.FC<Props> = ({
  is_multi_select,
  checked,
  checkedAndDisabled,
}) => {
  return (
    <div style={{ lineHeight: 0 }}>
      {is_multi_select ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
            className={`${
              checked && !checkedAndDisabled ? "fill-primary" : "fill-gray2"
            }`}
          />
          {checked && (
            <path
              d="M11.8485 5L6.82214 9.63691L4.14985 6.8948L3 8.07635L6.82214 12L13 6.18155L11.8485 5Z"
              className={!checkedAndDisabled ? "fill-primary" : "fill-gray2"}
            />
          )}
        </svg>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            className={`${
              checked && !checkedAndDisabled ? "fill-primary" : "fill-gray2"
            }`}
          />
          {checked && (
            <path
              d={
                checked
                  ? "M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z"
                  : "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
              }
              className={!checkedAndDisabled ? "fill-primary" : "fill-gray2"}
            />
          )}
        </svg>
      )}
    </div>
  );
};

export default SvgRadioCheckbox;
